import { ZafiroLogo } from '@/shared/components/ZafiroLogo';
import { ActivarCuentaForm } from '../ui/ActivarCuentaForm';
import '../ui/LoginForm.css';

export const ActivarCuentaPage = () => {
    return (
        <div className="login-container">
            <div className="login-content">
                {/* Logo fuera del formulario */}
                <div className="login-logo-section">
                    <ZafiroLogo />
                </div>

                <div className="login-card">
                    {/* Header */}
                    <div className="login-header">
                        <h1>Activar Cuenta</h1>
                        <p>Estamos activando tu cuenta en Zafiro</p>
                    </div>

                    <div className="login-form-content">
                        <ActivarCuentaForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActivarCuentaPage;
